import { type LegacyCMSCategoryPage } from './types';

export enum CMS_LOCALES {
  en = 'en-US',
}

export const CONTENTFUL_SPACE_ID = 'itoh30v6uh9a';
export const CONTENTFUL_DEFAULT_ENVIRONMENT = 'master';
export const CONTENTFUL_IMAGE_HOSTNAME = 'images.ctfassets.net';
export const DEPOP_CMS_CDN_HOSTNAME = 'contentful.depop.com';
export const CONTENTFUL_ATTEMPT_TIMEOUT_MS = 5000;
export const CONTENTFUL_DIRECT_RETRY_LIMIT = 2;

export const LEGACY_DEFAULT_CMS_CATEGORY_PAGE: LegacyCMSCategoryPage = {
  title: '',
  category: {
    id: 0,
    name: '',
    slug: '',
    parentId: 0,
    children: [],
  },
  copy: '',
  seo: {},
};
